import { cn } from "@/lib/utils";

/** Solid kort med valfri tittel-rad. Brukast til alle innhaldsblokker for konsistent rytme. */
export const Section = ({ title, description, actions, children, className, bodyClassName, padded = true, testId }) => (
  <section className={cn("rounded-lg border border-border bg-card", className)} data-testid={testId}>
    {title || actions ? (
      <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-2.5 md:px-5">
        <div className="min-w-0">
          {title ? <h2 className="text-[13px] font-semibold leading-5">{title}</h2> : null}
          {description ? <p className="mt-0.5 text-xs leading-5 text-muted-foreground">{description}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    ) : null}
    <div className={cn(padded && "p-4 md:p-5", bodyClassName)}>{children}</div>
  </section>
);

/** Nøkkeltal på ei linje med skiljestrekar – ingen boksar, ingen ikon-pynt. */
export const KeyFigures = ({ items, className, testId }) => (
  <dl className={cn("grid grid-cols-2 divide-border rounded-lg border border-border bg-card sm:flex sm:divide-x", className)} data-testid={testId}>
    {items.map((it, i) => (
      <div key={it.label} className={cn("min-w-0 px-4 py-3 sm:flex-1", i % 2 === 1 && "border-l border-border sm:border-l-0", i >= 2 && "border-t border-border sm:border-t-0")} data-testid={it.testId}>
        <dt className="truncate text-xs text-muted-foreground">{it.label}</dt>
        <dd className={cn("mt-0.5 truncate text-[15px] font-semibold leading-6", it.mono !== false && "num")}>{it.value}</dd>
        {it.hint ? <p className="truncate text-[11px] text-muted-foreground">{it.hint}</p> : null}
      </div>
    ))}
  </dl>
);

/** Nøkkeltal-kort (kompakt). */
export const StatCard = ({ icon: Icon, label, value, hint, className, testId }) => (
  <div className={cn("rounded-lg border border-border bg-card px-4 py-3", className)} data-testid={testId}>
    <p className="flex items-center gap-1.5 text-xs text-muted-foreground">{Icon ? <Icon className="h-3.5 w-3.5" /> : null}{label}</p>
    <p className="num mt-0.5 truncate text-[15px] font-semibold leading-6">{value}</p>
    {hint ? <p className="truncate text-[11px] text-muted-foreground">{hint}</p> : null}
  </div>
);

/** Etikett + verdi, til oversiktsfelt. */
export const Field = ({ label, children, className, testId }) => (
  <div className={cn("min-w-0", className)} data-testid={testId}>
    <p className="text-xs text-muted-foreground">{label}</p>
    <div className="mt-0.5 text-sm leading-6">{children}</div>
  </div>
);
